var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.showNewTimeReport)?_c('OldGuiFrame'):_c('TimeReportTable',{attrs:{"height":_vm.contentHeight,"reportFilter":_vm.reportFilter,"defaultColumns":_vm.columns,"tableStorageKey":'TimeReportTable'}})}
var staticRenderFns = []

export { render, staticRenderFns }